import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import Link from "ds/components/Link";
import useTypedFlags from "hooks/useTypedFlags";
import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";

import { CellComponentProps } from "../types";

type UserIdpGroupsListItemNameCellProps = CellComponentProps;

const UserIdpGroupsListItemNameCell = ({ group }: UserIdpGroupsListItemNameCellProps) => {
  const { customAccessRolesV2 } = useTypedFlags();
  if (!customAccessRolesV2) {
    return (
      <TextEllipsis tooltip={group.groupName} tooltipWidthMode="maxWidthSm">
        {(props) => (
          <Typography {...props} tag="p" variant="p-body3">
            {group.groupName}
          </Typography>
        )}
      </TextEllipsis>
    );
  }

  return (
    <Link
      analyticsPage={AnalyticsPageOrganization.OrganizationUserIdpGroups}
      analyticsTitle="Group Name Clicked"
      analyticsProps={{
        groupName: group.groupName,
      }}
      size="small"
      variant="secondary"
      href={`/settings/idp-group/${group.id}`}
    >
      {group.groupName}
    </Link>
  );
};

export default UserIdpGroupsListItemNameCell;
